export const ERROR_PAGE_INFO: Record<string, { code: string; title: string; desc: string }> = {
  404: {
    code: '404',
    title: 'Page Not Found',
    desc: "This page doesn't exist or was removed. Click the buttons below to explore more styles.",
  },
  410: {
    code: '410',
    title: 'Product Not Found',
    desc: 'This item has been permanently removed. Click the buttons below to explore more styles.',
  },
  activity: {
    code: '',
    title: 'Special Offer Has Ended',
    desc: 'Missed the sale? No worries, fresh styles and exclusive looks await on our homepage.',
  },
};

export const ERROR_BTN_LIST: { btn_name: string; url: string }[] = [
  {
    btn_name: 'VIEW ALL EYEGLASSES',
    url: '/goods-list/70',
  },
  {
    btn_name: 'VIEW ALL SUNGLASSES',
    url: '/goods-list/217',
  },
  {
    btn_name: 'BACK TO HOMEPAGE',
    url: '/',
  },
];
